import {
  defineComponent,
} from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    initOpen: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    defaultSku: {
      type: String,
      default: null,
    },
    downloads: {
      type: Array,
      default: () => [],
    },
    isSos: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data(props: any) {
    return {
      opened: props.initOpen,
    };
  },
  computed: {
    isCustomer() {
      return this.$store.getters.statuses.isCustomer;
    },
    isStopped() {
      return this.$store.getters.statuses.isStopped;
    },
    mixedDownloads() {
      let mixed = this.downloads;
      const privateDownloads = this.$store.getters.privateDownloads(this.defaultSku);
      if (privateDownloads && privateDownloads.length) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        privateDownloads.forEach((download: any) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          mixed = [...mixed.map((item: any) => (item !== download ? item : download))];
        })
      }
      return mixed;
    },
  },
  watch: {
    isCustomer() {
      if (this.isCustomer && !this.isStopped) {
        this.getPrivateDownloads();
      }
    },
    isStopped() {
      if (this.isCustomer && !this.isStopped) {
        this.getPrivateDownloads();
      }
    },
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
    getPrivateDownloads() {
      if (this.isCustomer && !this.isStopped) {
        // Trigger vuex action to retrieve private downloads for product
        this.$store.dispatch('getPrivateDownloads', this.defaultSku);
      }
    },
    getFilename(url: string) {
      const split = url.split('/');
      const filename = split[split.length - 1];

      const regex = /([^/]*.)\./;
      const match = filename.match(regex);
      if (!match || match && match.length < 2)  {
        return;
      }
      return decodeURI(match[1]);
    },
    getFileType(url: string) {
      const split = url.split('/');
      const filename = split[split.length - 1];

      const regex = /([^.]*.)$/;
      const match = filename.match(regex);
      if (!match || match && match.length < 2)  {
        return;
      }
      return match[1].toUpperCase();
    },
  },
  template: '#t-product-downloads',
});
